export const GET_CATEGORY = "GET_CATEGORY";
export const LOADING = "LOADING";
export const LOADED = "LOADED";
export const APP_STATUS = "APP_STATUS";
export const UPDATE_LIMIT = "UPDATE_LIMIT";
